import script from "./UserManagement.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserManagement.vue?vue&type=script&setup=true&lang=ts"

import "./UserManagement.vue?vue&type=style&index=0&id=77981f92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77981f92"]])

export default __exports__